import { CommApiInstance } from "Utils/CommApiInstance";

const MembOtpRegScrtApi = async () => {
    return await CommApiInstance.post(`memb/otp/get`,{
        apiBody:{

        },
    })
    .then((Resp) => Resp.data);
}
export default MembOtpRegScrtApi;